import _slicedToArray from "/Users/pranavkumar/githubPrisma/loretta-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useRef } from 'react';
import isFunction from './shared/isFunction';
import createHandlerSetter from './factory/createHandlerSetter';
/**
 * Returns a callback setter for a function to be performed when the component did mount.
 */
var useDidMount = function useDidMount(callback) {
  var mountRef = useRef(false);
  var _createHandlerSetter = createHandlerSetter(callback),
    _createHandlerSetter2 = _slicedToArray(_createHandlerSetter, 2),
    handler = _createHandlerSetter2[0],
    setHandler = _createHandlerSetter2[1];
  useEffect(function () {
    if (isFunction(handler === null || handler === void 0 ? void 0 : handler.current) && !mountRef.current) {
      handler.current();
      mountRef.current = true;
    }
  }, []);
  return setHandler;
};
export default useDidMount;